import { APPSUMO_PLUS_DEAL_ID } from '~/lib/util/constants';
import { DEFAULT_BILLING_DETAILS, COUNTRIES_LIST } from '~/constants/checkout';
import { CartProps } from '~/types/cart';
import { UserObjectProps } from '~/types/user';
import { BillingDetailsProps } from '~/types/checkout';

export const isFreebie = (cart?: CartProps): boolean =>
  cart?.subtotal === 0 && cart?.cart_items?.length > 0;

export const cartContainsPlusDeal = (cart?: CartProps): boolean =>
  !!cart?.cart_items?.some((item) => item.deal?.id === APPSUMO_PLUS_DEAL_ID);

export const canPayWithCredits = (cart?: CartProps): boolean =>
  !!(cart?.use_credit && cart?.credit && cart?.total === 0);

export const canPayWithPayPal = (cart?: CartProps): boolean => {
  if (!cart?.cart_items?.length) return false;

  return !cartContainsPlusDeal(cart);
};

export const getBillingDetailsObj = (
  user: UserObjectProps | null,
): BillingDetailsProps => {
  if (!user?.id) return DEFAULT_BILLING_DETAILS;

  // Get the billing country id in preparation for multiple billing addresses
  const defaultBillingDetails = user?.billing_address_list?.find(
    (address) => address.is_default,
  );
  const defaultBillingId =
    defaultBillingDetails?.country.value === user.billing_country?.value &&
    defaultBillingDetails?.postal_code === user.billing_postal_code
      ? `${defaultBillingDetails?.id}`
      : '';

  return {
    country: user.billing_country?.value
      ? user.billing_country
      : COUNTRIES_LIST[0],
    billingName: user.billing_name ?? '',
    billingAddress1: user.billing_address1 ?? '',
    billingAddress2: user.billing_address2 ?? '',
    billingCity: user.billing_city ?? '',
    billingState: user.billing_state ?? '',
    billingId: defaultBillingId,
    postalCode: user.billing_postal_code ?? '',
    taxId: user.default_tax_infomation?.tax_id ?? '',
    taxBusinessName: user.default_tax_infomation?.business_name ?? '',
    taxType: user.default_tax_infomation?.type ?? '',
    showTaxCollection: !!user.default_tax_infomation?.tax_id,
    saveBillingInfo: true,
    username: user.username,
    defaultTaxInformation: {
      taxId: user.default_tax_infomation?.generic_tax_id,
      businessName: user.default_tax_infomation?.generic_business_name,
      type: user.default_tax_infomation?.generic_type,
      country: user.default_tax_infomation?.generic_country,
      isTaxExempt: !!user.default_tax_infomation?.is_tax_exempt,
      taxExemptStartDate:
        user.default_tax_infomation?.tax_exempt_start_date || '',
      taxExemptEndDate: user.default_tax_infomation?.tax_exempt_end_date || '',
    },
  };
};
